import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import AmazonCredentials from "./Credentials/amazon";
import GoogleCredentials from "./Credentials/google";
import PrepBusinessCredentials from "./Credentials/prepbusiness";
import SellerlogicCredentials from "./Credentials/sellerlogic";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const CredentialsTab = () => {
  const [credentialsSubTab, setCredentialsSubTab] = useState(0);

  const handleCredentialsSubTabChange = (event, newValue) => {
    setCredentialsSubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={credentialsSubTab}
              onChange={handleCredentialsSubTabChange}
              aria-label="credentials tabs"
            >
              <Tab label="Amazon Credentials" />
              <Tab label="Google Credentials" />
              <Tab label="Prepbusiness Credentials" />
              <Tab label="Sellerlogic Credentials" />
            </Tabs>
          </Box>

          {/* Amazon Credentials Tab */}
          <TabPanel value={credentialsSubTab} index={0}>
            <AmazonCredentials />
          </TabPanel>

          {/* Google Credentials Tab */}
          <TabPanel value={credentialsSubTab} index={1}>
            <GoogleCredentials />
          </TabPanel>

          {/* Prepbusiness Credentials Tab */}
          <TabPanel value={credentialsSubTab} index={2}>
            <PrepBusinessCredentials />
          </TabPanel>

          {/* Sellerlogic Credentials Tab */}
          <TabPanel value={credentialsSubTab} index={3}>
            <SellerlogicCredentials />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CredentialsTab;
